import React from 'react';

/**
 * Compact task card for the task list.
 * Shows robot number, error, priority, location, and estimated time.
 */

const PRIORITY_COLORS = {
  CRITICAL: '#d63031',
  HIGH: '#e17055',
  NORMAL: '#fdcb6e',
  LOW: '#00b894',
};

const STATUS_BADGES = {
  pending: { bg: '#30363d', label: 'Pending' },
  assigned: { bg: '#6c5ce7', label: 'Assigned' },
  in_progress: { bg: '#0984e3', label: 'In Progress' },
  completed: { bg: '#00b894', label: 'Done' },
  escalated: { bg: '#e17055', label: 'Escalated' },
};

export default function TaskCard({ task, onClick, t, index }) {
  const priorityColor = PRIORITY_COLORS[task.priority] || '#8b949e';
  const statusInfo = STATUS_BADGES[task.status] || STATUS_BADGES.pending;

  return (
    <div
      onClick={onClick}
      style={{
        background: '#161b22',
        borderRadius: 12,
        padding: '14px 16px',
        marginBottom: 10,
        cursor: 'pointer',
        borderLeft: `4px solid ${priorityColor}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      {/* Top row: robot + priority */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, color: '#8b949e' }}>#{index + 1}</span>
          <span style={{ fontSize: 17, fontWeight: 700, color: '#e6edf3' }}>
            {t?.robot || 'Robot'} {task.robot_number}
          </span>
        </div>
        <span style={{
          fontSize: 11,
          fontWeight: 600,
          padding: '3px 8px',
          borderRadius: 6,
          background: priorityColor + '22',
          color: priorityColor,
          textTransform: 'uppercase',
        }}>
          {t?.[task.priority?.toLowerCase()] || task.priority}
        </span>
      </div>

      {/* Error code */}
      <div style={{ fontSize: 13, color: '#b1bac4' }}>
        {task.error?.replace(/_/g, ' ')}
      </div>

      {/* Supplementary faults indicator */}
      {task.supplementary_faults?.length > 0 && (
        <div style={{
          fontSize: 11, color: '#fdcb6e', background: '#fdcb6e11',
          padding: '3px 8px', borderRadius: 6, display: 'inline-block',
        }}>
          ⚠ +{task.supplementary_faults.length} {t?.additionalFaults || 'additional faults this week'}
        </div>
      )}

      {/* Motor enrichment indicator */}
      {task.motor_enrichment && (
        <div style={{
          fontSize: 11, color: '#74b9ff', background: '#74b9ff11',
          padding: '3px 8px', borderRadius: 6, display: 'inline-block',
        }}>
          🔧 {t?.motorDetails || 'Motor fault details available'}
        </div>
      )}

      {/* Bottom row: location + time + status */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ fontSize: 12, color: '#8b949e', display: 'flex', gap: 12 }}>
          <span>{t?.row || 'R'}{task.row}</span>
          <span>{t?.group || 'G'}{task.group}</span>
          <span>{task.estimated_minutes} {t?.minutes || 'min'}</span>
        </div>
        <span style={{
          fontSize: 10,
          padding: '2px 6px',
          borderRadius: 4,
          background: statusInfo.bg,
          color: '#e6edf3',
        }}>
          {statusInfo.label}
        </span>
      </div>
    </div>
  );
}
